import { sha256_hashing } from "./facebookHelper";
import { sendServerEvent } from "../../../api/facebookEventTrackerApi";

/**
 * These methods create/execute scripts that are typically embedded in a page via <script> tags.
 */
export default {
  /**
   * @param {Boolean} isProduction
   * @param {String} event - The Facebook event data.
   * @param {Object} [data] - Data to send along with the fbq call.
   * @param {String} [eventType = "track"] - Event type we send to facebook it should be either "track" or "trackCustom". This is used as the first parameter to 'fbq'.
   * @param {String} [userEmail] - The email of the user related to the event.
   */
  facebook: async function(isProduction, event, data = {}, eventType = "track", userEmail= null) {
    try {
      if (!isProduction) {
        return console.log("Facebook (fbq) script. Event: ", event);
      }

      const em = await sha256_hashing(userEmail);
      const {event_uuid} = await sendServerEvent(event, data, userEmail);

      if (event_uuid && window.fbq) {
        window.fbq(eventType, event, {em, ...data}, {eventID: event_uuid});
      }
    }
    catch (ex) {
      console.error("trackingScripts.facebook() failed.");
    }
  },

  /**
   * @param {Boolean} isProduction
   * @param {Object} order
   */
  googleECommerce: function(isProduction, order) {
    // Build a new products array with the data we're looking to collect.
    const products = [];
    order.orderProducts.forEach(orderProduct => {
      products.push({
        discount: orderProduct.discount,
        product_id: orderProduct.productId,
        price: orderProduct.price,
        quantity: orderProduct.quantity,
        total_price: orderProduct.totalPrice
      });
    });

    // Construct our ecommerce data, converting it to a JSON string.
    const eComData = {
      ecommerce: {
        order: {
          customer_id: order.customerId,
          order_id: order.id,
          promo_code_id: order.promoCodeId,
          promo_discount: order.promoDiscount,
          shipping_price: order.shippingPrice,
          subtotal: order.subtotal,
          total_price: order.totalPrice
        },
        products: products
      }
    };

    if (isProduction) {
      // Send off the collected data to GA.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(JSON.stringify(eComData));
    }
    else {
      console.log("Google eCommerce data: ", eComData);
    }
  },

  googleConversionGTag(isProduction) {
    if (!isProduction)
      return console.log("Google conversion gTag");

    // Event snippet for Shapa Purchase conversion page
    if (window.gtag) {
      window.gtag("event", "conversion", {
        "send_to": "AW-819746548/od25CNHs13sQ9K3xhgM",
        "transaction_id": ""
      });
    }
  },

  sendGoogleAnalyticsEvent(isProduction, eventAction, eventCategory, eventLabel) {
    const eventObject = {
      event_category: eventCategory,
      event_label: eventLabel
    };

    if (!isProduction)
      return console.log("Google Analytics event: ", eventAction, eventObject);

    if (window.gtag) {
      window.gtag("event", eventAction, eventObject);
    }
  },

  /**
   * @param {Boolean} isProduction
   * @param {String} URL - The second argument can be a relative or full URL.
   */
  hotjar: async function(isProduction, URL) {
    try {
      if (!isProduction) {
        return console.log("HotJar (hj) script. stateChange URL: ", URL);
      }

      if (window.hj) {
        window.hj("stateChange", URL);
      }
    }
    catch (ex) {
      console.error("trackingScripts.hotjar() failed.");
    }
  },
};
